import { cn } from '@planuze/ui';

/* Grupo de pills de escolha única (ADR-0704). Substitui os Selects de status/segmento nas
   toolbars quando o conjunto de opções é pequeno e vale ficar sempre visível (scannability).
   Opcionalmente mostra um contador por opção (ex.: nº de itens em cada status). */
export interface SegmentOption<T extends string> {
  readonly value: T;
  readonly label: string;
  readonly count?: number;
}

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  ariaLabel,
}: {
  readonly value: T;
  readonly onChange: (value: T) => void;
  readonly options: readonly SegmentOption<T>[];
  readonly ariaLabel: string;
}) {
  return (
    <fieldset className="inline-flex flex-wrap items-center gap-1 rounded-lg border border-border bg-muted/40 p-1">
      <legend className="sr-only">{ariaLabel}</legend>
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-sm font-medium transition-colors',
              active
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:bg-accent/15 hover:text-foreground',
            )}
          >
            {opt.label}
            {opt.count !== undefined && (
              <span
                className={cn(
                  'rounded-full px-1.5 text-xs tabular-nums',
                  active ? 'bg-accent/15 text-foreground' : 'bg-muted text-muted-foreground',
                )}
              >
                {opt.count}
              </span>
            )}
          </button>
        );
      })}
    </fieldset>
  );
}
